<template>
  <section :class="['cs-header', { 'position-absolute w-100': isInIframe }]">
    <div class="cs-header__close py-2">
      <div class="d-flex align-items-center">
        <div class="cs-header__left">
          <template v-if="marketInfo.merchant && marketInfo.merchant.shopData">
            <img
              v-if="
                marketInfo &&
                marketInfo.merchant &&
                marketInfo.merchant.shopData &&
                marketInfo.merchant.shopData.logo
              "
              class="cs-header__shop-icon"
              :class="{
                'cs-header__shop-icon_sky-tours':
                  marketInfo.merchant.shopData.companyName === 'Sky-tours',
              }"
              :src="marketInfo.merchant.shopData.logo"
              alt="logo"
            />
            <div
              id="shop-name"
              v-if="marketInfo.merchant.shopData.companyName !== 'Sky-tours'"
              class="cs-header__shop-name"
            >
              {{ marketInfo.merchant.shopData.companyName }}
            </div>
            <b-tooltip target="shop-name" triggers="hover" placement="top">
              {{ marketInfo.merchant.shopData.companyName }}
            </b-tooltip>
          </template>
        </div>
        <div class="d-flex ml-1">
          <div class="cs-header__tip" title="Support">
            <a
              :href="supportLink"
              target="_blank"
            >
              <img
                width="90%"
                src="@/assets/img/support.svg"
                alt="tip"
                class="cs-header__tip__icon"
              />
            </a>
          </div>
          <div class="ml-1" v-if="cryptoWalletStep !== 2">
            <router-link
              v-if="$route.meta.settings"
              class="cs-header__settings"
              :to="{ name: 'Settings' }"
              @click="handleSettingEvent"
            >
              <img
                src="@/assets/img/settings.svg"
                alt="settings"
                class="cs-header__icon"
              />
            </router-link>
          </div>
          <div class="cs-header__tip ml-1" v-if="cryptoWalletStep !== 2">
            <img
              id="tip"
              width="80%"
              src="@/assets/img/questionMark.svg"
              alt="tip"
              class="cs-header__tip__icon"
            />
            <b-tooltip
              target="tip"
              class="tip"
              triggers="hover"
              placement="top"
            >
              {{ changePartnerLabelName(marketInfo, "sign-up.tipMessage") }}
            </b-tooltip>
          </div>
          <div
            class="cs-header__right ml-1"
            v-if="!isWelcomePage() && isInIframe"
          >
            <div
              title="close"
              class="cs-header__btn"
              id="closeBtnIframe"
              @click="triggerCloseModel"
            >
              <img
                src="@/assets/img/close.svg"
                alt="close btn "
                id="closebtn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <PopupModal
      v-if="iframeDismissConfirmVisible"
      id="2"
      :title="$t('closing-modal.title')"
      :showModal="true"
      :description="
        $t('closing-modal.description') + $t('closing-modal.description2')
      "
      :cancel="$t('closing-modal.cancel')"
      :dismiss="$t('closing-modal.dismiss')"
      @cancelClicked="onCancelCloseConfirm"
      @dismissClicked="onConfirmCloseIframe"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import PopupModal from "@/components/PopupModal.vue";
import {
  USER_TRACK_EVENTS,
  IFRAME_STATUS,
  IFRAME_STATUS_CLOSE,
} from "@/store/modules/user/consts";
import { routeEnum } from "../store/modules/auth/enum";
import { RESET_IFRAME_CLOSE_MODAL } from "@/utils/event.constants";
import { releasePaymentResult } from "@/utils/paymentResultEvents";
import { teardownBootstrapModals } from "@/utils/modalCleanup";
import {
  loadMerchantMarketInfo,
  prefetchPaymentBootstrap,
} from "@/utils/paymentBootstrap";
import {
  getCartSessionKey,
  getCurrenciesCacheKey,
} from "@/utils/sessionDataCache";

// import MultiDropdown from '@/components/MultiDropdown.vue';

export default {
  name: "BankComponent",
  mounted() {
    this.resetCloseModalState();
    this.onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        this.resetCloseModalState();
      }
    };
    document.addEventListener("visibilitychange", this.onVisibilityChange);

    // this.$refs.loader.end();
    this.$nextTick(async () => {
      // this.$refs.loader.start();
      if (Object.values(this.cart).length) {
        await this.getData();
        // this.$refs.loader.end();
      } else {
        window.EventBus.emit("ADD_INFO_MESSAGE", {
          message: "waiting cart...",
        });
      }
    });
    window.EventBus.on("is-preview", (val) => {
      this.isPreview = val;
    });
    window.EventBus.on("PopupClosed", (popup) => {
      this.PopupClosed = popup;
    });
    window.EventBus.on(RESET_IFRAME_CLOSE_MODAL, this.resetCloseModalState);
  },
  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.EventBus.off(RESET_IFRAME_CLOSE_MODAL, this.resetCloseModalState);
    this.resetCloseModalState();
  },
  components: {
    // MultiDropdown,
    PopupModal,
  },
  data() {
    return {
      isPreview: "",
      PopupClosed: null,
      onVisibilityChange: null,
      isClosingIframe: false,
    };
  },
  watch: {
    async cart(newCart, oldCart) {
      if (newCart?.uuid && newCart?.uuid !== oldCart?.uuid) {
        this.resetCloseModalState();
      }
      if (!newCart || !Object.values(newCart).length) {
        return;
      }
      const prevCurrencyKey = getCurrenciesCacheKey(oldCart);
      const nextCurrencyKey = getCurrenciesCacheKey(newCart);
      const prevSessionKey = getCartSessionKey(oldCart);
      const nextSessionKey = getCartSessionKey(newCart);
      if (
        prevCurrencyKey &&
        nextCurrencyKey === prevCurrencyKey &&
        prevSessionKey &&
        nextSessionKey === prevSessionKey
      ) {
        return;
      }
      window.EventBus.emit("DELETE_INFO_MESSAGE", {
        message: "waiting cart...",
      });
      await this.getData();
    },
  },
  computed: {
    ...mapGetters({
      cart: "user/cart",
      initialCart: "user/initialCart",
      redirectUrl: "user/getRedirectUrl",
      tab: "user/tab",
      marketInfo: "user/marketInfo",
      paymentCompleted: "auth/paymentCompleted",
      cryptoWalletStep: "user/getCryptoWalletStep",
      iframeDismissConfirmVisible: "user/iframeDismissConfirmVisible",
    }),
    supportLink() {
      return (
        process.env.VUE_APP_SUPPORT_LINK ||
        "https://rocketfuelblockchain.zendesk.com/hc/en-us/requests/new"
      );
    },
    isInIframe() {
      return window.top !== window.self;
    },
  },
  methods: {
    resetCloseModalState() {
      this.isClosingIframe = false;
      this.$store.commit("user/setIframeDismissConfirmVisible", false);
      this.$nextTick(() => {
        this.$bvModal.hide("modal-2");
        teardownBootstrapModals("modal-2");
      });
    },
    onCancelCloseConfirm() {
      this.resetCloseModalState();
    },
    triggerCloseModel() {
      if (!this.isPreview && this.tab === "Crypto Wallet") {
        this.$store.commit("user/setIframeDismissConfirmVisible", true);
      } else {
        this.onConfirmCloseIframe();
      }
    },
    onConfirmCloseIframe() {
      this.closeIFrame();
    },
    async getData() {
      await loadMerchantMarketInfo(this.$store, this.cart);
      if (this.$store.getters["auth/isAuth"]) {
        await prefetchPaymentBootstrap(this.$store, this.cart);
      }
    },
    closeIFrame() {
      if (this.isClosingIframe) {
        return;
      }
      this.isClosingIframe = true;
      this.resetCloseModalState();

      // Payment result may be held back while the rewards screen is open
      releasePaymentResult();

      const paymentCompleted = this.paymentCompleted ? 1 : 0;
      const closeModalMessage = {
        type: "CLOSE_MODAL",
        paymentCompleted,
      };
      const closeIframeMessage = {
        type: "rocketfuel_iframe_close",
        paymentCompleted,
        redirectUrl: this.redirectUrl || "",
      };

      if (window.parent) {
        window.parent.postMessage(closeModalMessage, "*");
        window.parent.postMessage(closeIframeMessage, "*");
      }
      if (window.top && window.top !== window.parent) {
        window.top.postMessage(closeModalMessage, "*");
        window.top.postMessage(closeIframeMessage, "*");
      }

      const cartSource =
        this.initialCart?.order || this.initialCart?.uuid
          ? this.initialCart
          : this.cart;

      Promise.all([
        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Header",
            activity: "iframe closed",
          },
        }),
        cartSource?.order || cartSource?.uuid
          ? this.$store.dispatch(`user/${IFRAME_STATUS}`, {
              offerId: cartSource.order,
              hostedPageId: cartSource.uuid,
              merchantId: cartSource.merchant_id,
              status: IFRAME_STATUS_CLOSE,
            })
          : Promise.resolve(),
      ]).catch((err) => {
        console.error("[Header] closeIFrame tracking failed:", err);
      });
    },
    async handleSettingEvent() {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Payment Page",
          activity: "clicked on setting button",
        },
      });
    },
    isWelcomePage() {
      return this.$route.name === routeEnum.WELCOME;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.cs-header {
  padding: 0 10px;
  z-index: 1;
  min-height: 50px;
  top: 0;
  left: 0;
  background-color: #f4f6fb;
  border-bottom: 1px solid rgba(27, 31, 59, 0.08);
  border-radius: 8px 8px 0 0;
  /*
  display: flex;
  align-items: center;
  justify-content: space-between;
  */
  transition: 0.3s;
  &_scrolled {
    box-shadow: 0px 3px 5px rgba(32, 42, 68, 0.12);
  }
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 0px;
    &__icon {
      border: none;
      margin: 0;
    }
  }
  &__left,
  &__right {
    display: flex;
    align-items: center;
  }

  &__left {
    // max-width: 230px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__right {
    justify-content: flex-end;
  }

  &__logo {
    width: 28px;
    min-width: 28px;
    object-fit: contain;
    margin-right: 14px;
  }

  &__shop-icon {
    height: 50px;
    margin-right: 10px;
    // margin-bottom: 5px;
    // TODO это временное решение имеено для sky-tours
    &_sky-tours {
      width: 135px;
      object-fit: cover;
    }
  }

  &__shop-name {
    font-size: 22px;
    line-height: 21px;
    font-weight: 600;
    min-width: 75px;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  &__title {
    width: 159px;
    min-width: 159px;
    object-fit: contain;
  }

  &__btn {
    @include gradient-box;
    background-color: $white;
    width: 25px;
    min-width: 25px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    border: none;
    z-index: 9999999999;
    & img {
      width: 18px;
    }
    &:hover {
      background-color: $gradient-grey;
    }
  }

  &__settings {
    @include gradient-box;
    background-color: $white;
    border: none;
    width: 25px;
    min-width: 20px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    border-radius: 50%;
    img {
      padding: 2px;
    }
    &:hover {
      background-color: $gradient-grey;
      & img {
        animation: rotate 1.25s linear infinite;
      }
    }
  }

  &__login {
    @include gradient-box;
    background-color: $white;
    width: 90px;
    min-width: 90px;
    height: 30px;
    object-fit: contain;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 23px;
    transition: 0.3s;
    &:hover {
      background-color: $gradient-grey;
    }
    & img {
      width: 14px;
      margin-right: 7px;
    }
  }
  &__close {
    /* display: flex; */
    justify-content: space-between;
    align-items: center;
  }
  &__tip {
    // @include gradient-box;
    // border: 1px solid #1D1D3F;
    // background-color: $white;
    width: 25px;
    min-width: 20px;
    height: 25px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    // border-radius: 50%;
    // padding: 2px;
    margin-left: 8px;
    &__icon {
      height: 100%;
      width: 20px;
      cursor: pointer;
      // border-radius: 50%;
    }
  }
}

.close-modal {
  &__title {
    font-size: 17px;
  }

  &__desc {
    background: rgba(0, 0, 0, 0.05);
    padding: 10px;
    font-size: 13px;
  }

  &__footer-btn {
    padding: 0px 10px;
    cursor: pointer;
    border-radius: 5px;
    color: #5559fe;
    margin: 0px 5px;
    border: 1px solid #5559fe;
  }

  &__footer-btn:nth-child(2) {
    background: #5559fe;
    color: white;
  }

  &__info-img {
    margin-top: -75px;
    margin-right: 10px;
  }

  &__action-btns {
    display: block;
    margin: auto;
  }
}

::v-deep(.modal-header) {
  border: none !important;
  padding: 0px 5px;
}

::v-deep(.modal-footer) {
  border: none !important;
  padding-bottom: 20px;
}

::v-deep(.modal) {
  padding: 0px !important;
}
</style>
